import type { ReactNode } from 'react';

import * as HC from '@radix-ui/react-hover-card';
import clsx from 'clsx';

import { ReactComponent as Information } from '@quick/assets/icons/information.svg';

export function InfoHover({
  children,
  className,
  contentClassName = 'z-100',
  triggerClassName,
}: {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  triggerClassName?: string;
}) {
  return (
    <HC.Root>
      <HC.Trigger className={triggerClassName}>
        <Information
          className={clsx(
            'text-brand hover:text-brand-dark h-4 w-4 rounded-full',
            className
          )}
        />
      </HC.Trigger>
      <HC.Portal>
        <HC.Content
          className={clsx(
            `dark:bg-background-group-dark dark:border-background-dark bg-white text-gray-800
            dark:text-gray-200`,
            `motion-safe:animate-slideUpAndFade max-w-sm rounded border-2 border-gray-200 p-4
            lg:max-w-md`,
            contentClassName
          )}
          sideOffset={5}
        >
          {children}
          <HC.Arrow className="dark:fill-background-dark fill-gray-200" />
        </HC.Content>
      </HC.Portal>
    </HC.Root>
  );
}
